import { useState } from 'react';

import { ParsedJobItem } from 'src/api/hooks/useJob.types';
import { Role } from 'src/DTO/Role.type';
import { useXmlFeedImport } from './useXmlFeedImport';
import { Job } from 'src/DTO/Job.type';

export const useJobCreation = () => {
  const feedImport = useXmlFeedImport();

  const [isJobTypeDialogOpen, setIsJobTypeDialogOpen] = useState<boolean>(false);
  const [parsedJobData, setParsedJobData] = useState<Job | undefined>();
  const [parsedRoleData, setParsedRoleData] = useState<Role | undefined>();
  const [dialogKey, setDialogKey] = useState<number>(0);

  const [isManualJobDialogOpen, setIsManualJobDialogOpen] = useState(false);

  const openJobTypeDialog = () => {
    setIsJobTypeDialogOpen(true);
    feedImport.fetchJobsFromCache();
  };

  const closeJobTypeDialog = () => {
    setIsJobTypeDialogOpen(false);
  };

  const openManualJobDialog = () => {
    setIsJobTypeDialogOpen(false);
    setParsedJobData(undefined);
    setParsedRoleData(undefined);
    feedImport.stopImporting();
    setIsManualJobDialogOpen(true);
  };

  const openFeedDialog = () => {
    setIsJobTypeDialogOpen(true);
    feedImport.openFeedDialog();
  };

  const setManualJobDialogOpen = (open: boolean) => {
    if (!open) {
      setParsedJobData(undefined);
      setParsedRoleData(undefined);
    }
    setIsManualJobDialogOpen(open);
  };

  const prefillFromParsedJob = (job: ParsedJobItem) => {
    setParsedJobData(job.jobData);
    setParsedRoleData(job.roleData);
    setDialogKey(prev => prev + 1);
    setIsManualJobDialogOpen(true);
  };

  const handleFeedJobSaved = () => {
    const selectedJobs = feedImport.parsedJobs.filter((_, i) => feedImport.selectedIndexes.has(i));
    const nextIndex = feedImport.currentImportIndex + 1;

    if (nextIndex < selectedJobs.length) {
      feedImport.advanceImportIndex();
      prefillFromParsedJob(selectedJobs[nextIndex]);
    } else {
      const allJobsImported = selectedJobs.length === feedImport.parsedJobs.length;

      if (allJobsImported) {
        feedImport.resetFeed();
      } else {
        feedImport.stopImporting();
      }

      setParsedJobData(undefined);
      setParsedRoleData(undefined);
      setIsManualJobDialogOpen(false);
    }
  };

  const startFeedImport = () => {
    feedImport.startImporting();
    setIsJobTypeDialogOpen(false);
    const selectedJobs = feedImport.parsedJobs.filter((_, i) => feedImport.selectedIndexes.has(i));
    if (selectedJobs.length > 0) {
      prefillFromParsedJob(selectedJobs[0]);
    }
  };

  return {
    isJobTypeDialogOpen,
    isManualJobDialogOpen,
    parsedJobData,
    parsedRoleData,
    dialogKey,
    feedImport: {
      ...feedImport,
      startImporting: startFeedImport,
    },
    openJobTypeDialog,
    closeJobTypeDialog,
    openManualJobDialog,
    openFeedDialog,
    setManualJobDialogOpen,
    handleFeedJobSaved,
  };
};
